const fileTypeMapping = {
    jpg: { accept: [".jpg", ".jpeg"], mime: ["image/jpeg"] },
    png: { accept: [".png"], mime: ["image/png"] },
    pdf: { accept: [".pdf"], mime: ["application/pdf"] },
}

export type AllowedFileSelectionTypes = Array<keyof typeof fileTypeMapping>

export const getMimeTypes = (allowedFileTypes: AllowedFileSelectionTypes) => {
    const mime: Array<string> = []
    allowedFileTypes.forEach((type) => mime.push(...fileTypeMapping[type].mime))
    return mime
}

export const getAcceptAttribute = (allowedFileTypes: AllowedFileSelectionTypes) => {
    const accept: Array<string> = []
    allowedFileTypes.forEach((type) => accept.push(...fileTypeMapping[type].accept))
    return accept.join(", ")
}

export const getUploadMethods = (translateText: (key: string | number) => string) => {
    const uploadMethods = [
        { id: 1, method: translateText(13773) },
        { id: 2, method: translateText(12679) },
    ]
    return uploadMethods
}
